<template>
  <div class="sixt-wrap">
    <h3
      v-if="title"
      class="sixt-title"
    >
      {{ title }}
    </h3>
    <div
      id="mli-root"
      class="mli-loading"
      data-currency="EUR"
      :data-ptid="sixtAppId"
      :data-locale="selectedLocale"
    />
  </div>
</template>

<script>
  import conf from 'conf'
  import { mapState } from 'vuex'

  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      searchOnly: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        sixtAppId: conf.sixtAppId,
        sixtAppUrlSearch: conf.sixtAppUrlSearch,
        sixtAppUrlDirect: conf.sixtAppUrlDirect
      }
    },
    computed: {
      ...mapState('main', ['selectedCountry', 'selectedLang']),

      selectedLocale() {
        return `${this.selectedLang}-${this.selectedCountry}`
      }
    },
    mounted() {
      this.initSixt()
    },
    methods: {
      initSixt() {
        const sixtUrl = this.searchOnly ? this.sixtAppUrlSearch : this.sixtAppUrlDirect
        const url = `${sixtUrl}?ptid=${this.sixtAppId}`
        const script = document.querySelector(`script[src="${url}"]`)

        if (typeof script === 'undefined' || script === null) {
          const sixtScriptElement = document.createElement('script')
          sixtScriptElement.setAttribute('src', `${url}`)
          document.head.appendChild(sixtScriptElement)
        }
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .sixt-wrap {
    margin: 20px 0;

    .sixt-title {
      font-size: rem(24, 16);
      font-weight: 500;
      margin-bottom: 20px;
    }

    .mli-loading {
      width: 100%;
      height: 100%;
      min-height: rem(365, 16);
      position: relative;

      &:after {
        content: url('~assets/images/loader-small.svg');
        color: $grey-white;
        background-color: $grey-white;
        width: 100%;
        height: rem(365, 16);
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .mli-loaded {
      width: 100%;
      height: 100%;
      min-height: rem(365, 16);
    }
  }

  @include bp-mf-desktop-large {
    ::v-deep {
      .mli-dropdown-select {
        .mli-dropdown-container {
          width: rem(70, 16);
        }
      }
    }
  }
</style>
